!(function () {
  "use strict";
  var e,
    t = {
      227: function (e, t, n) {
        var o = n(5837),
          r = n(6358),
          i = n(4105),
          a = void 0 !== window.safari,
          s = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        let c = document.getElementById("nav-wrapper");
        (c.props = {}),
          (c.props.navMargin = 0),
          (c.props.transformAmount = 0),
          (c.props.lastScroll = window.scrollY),
          (c.props.submenuOpen = !1),
          (c.props.activeMenu = 0);
        const l = function () {
          const e = document.getElementById("overlay");
          if (
            "click" == document.querySelector(".header").getAttribute("data-ux")
          ) {
            c.querySelectorAll(".nav__content details > summary").forEach(
              (e) => {
                e.addEventListener("click", (e) => {
                  e.preventDefault();
                });
              }
            );
            const t = c.querySelectorAll("details.megamenu-open > summary");
            t.forEach((n) => {
              const r = () => {
                n.parentNode.classList.remove("active"),
                  n.parentNode.removeAttribute("open"),
                  window.setTimeout(() => {
                    e.classList.remove("open");
                  }, 2);
              };
              function l(t) {
                let o = window.matchMedia("(min-width: 1024px)");
                t.target.closest(".main-nav-item") ||
                  t.target.parentNode.classList.contains("main-nav-item") ||
                  t.target.parentNode.hasAttribute("open") ||
                  t.target.classList.contains("search-trigger") ||
                  t.target.classList.contains("search-icon") ||
                  t.target.classList.contains("icon") ||
                  !o.matches ||
                  (window.setTimeout(() => {
                    e.classList.remove("open");
                  }, 2),
                  n.parentNode.removeAttribute("open"),
                  c.removeEventListener("click", l, !1),
                  c.removeEventListener("mouseover", l, !1),
                  e.removeEventListener("mouseover", l, !1));
              }
              n.addEventListener("click", (u) => {
                (0, o.hF)(),
                  (0, i.gp)(!0, r),
                  window.setTimeout(() => {
                    e.classList.add("open"), (a || s) && d(n);
                  }, 1),
                  c.addEventListener("click", l, !1),
                  e.addEventListener("click", l, !1),
                  t.forEach((e) => {
                    e !== n &&
                      (e.classList.remove("active"),
                      e.parentNode.removeAttribute("open"));
                  }),
                  n.parentNode.hasAttribute("open") &&
                    window.setTimeout(() => {
                      e.classList.remove("open");
                    }, 2),
                  e.addEventListener("click", () => {
                    window.setTimeout(() => {
                      e.classList.remove("open");
                    }, 2),
                      n.parentNode.removeAttribute("open");
                  });
              });
            });
          } else
            c.querySelectorAll("details.megamenu-open").forEach((t) => {
              (t.onmouseover = function () {
                (0, o.hF)(),
                  this.classList.add("active"),
                  this.setAttribute("open", "true"),
                  window.setTimeout(() => {
                    e.classList.add("open"), (a || s) && d(t);
                  }, 1);
              }),
                (t.onmouseout = function () {
                  this.classList.remove("active"),
                    this.removeAttribute("open"),
                    window.setTimeout(() => {
                      e.classList.remove("open");
                    }, 2);
                });
            }),
              c.querySelectorAll("details > summary").forEach((e) => {
                e.addEventListener("click", (e) => {
                  e.preventDefault();
                });
              });
          c
            .querySelectorAll(".nav__main-menu--multi_level_megamenu details")
            .forEach((e) => {
              e.setAttribute("open", "true");
            }),
            document.querySelectorAll(".nav").forEach((e) => {
              (0, o.TS)(e);
            }),
            document.querySelectorAll(".nav").forEach((e) => {
              (e.props = {}),
                e.querySelectorAll(".nav__main-menu-link").forEach((t, n) => {
                  0 == n &&
                    t.parentNode.querySelector(
                      ".nav__secondary-navigation-item-content"
                    ) &&
                    (window.innerHeight - 140 >
                    t.parentNode.querySelector(
                      ".nav__secondary-navigation-item-content"
                    ).offsetHeight
                      ? (document.querySelector(
                          ".nav--multilevel .nav__content"
                        ).style.height =
                          t.parentNode.querySelector(
                            ".nav__secondary-navigation-item-content"
                          ).offsetHeight +
                          160 +
                          "px")
                      : (document.querySelector(
                          ".nav--multilevel .nav__content"
                        ).style.height = window.innerHeight - 140 + "px")),
                    window.matchMedia("(hover: hover)").matches &&
                      window.matchMedia("(min-width: 1024px)").matches &&
                      t.addEventListener("mouseover", () => {
                        (0, o.Uy)(t, e);
                      }),
                    t.addEventListener("focus", () => {
                      (0, o.Uy)(t, e);
                    }),
                    t.addEventListener("click", () => {
                      e.classList.add("nav--secondary-menu-open"),
                        (0, o.Uy)(t, e);
                      let n = t.getAttribute("data-targetmenu"),
                        i = e.querySelector(`#${n}`),
                        a = e.querySelector(".nav--mobile__inner-container");
                      e.classList.contains("nav--mobile") &&
                        (r.p8.to(e.querySelector(".container"), {
                          scrollTop: 0,
                          duration: 0.3,
                        }),
                        i.offsetHeight > 0 &&
                          (a.style.height = i.offsetHeight + "px"));
                    });
                }),
                e
                  .querySelectorAll(".nav__secondary-menu__close")
                  .forEach((t) => {
                    t.addEventListener("click", () => {
                      (0, o.TS)(e),
                        e.classList.contains("nav--mobile") &&
                          (e.querySelector(
                            ".nav--mobile__inner-container"
                          ).style.height = "auto");
                    });
                  }),
                e.querySelectorAll(".nav__mobile-close").forEach((t) => {
                  t.addEventListener("click", () => {
                    (0, o.Wj)(e);
                  });
                }),
                (0, o.sW)(e, !0);
            });
        };
        l(),
          Shopify.designMode
            ? document
                .getElementById("nav-wrapper")
                .classList.add("header-visible", "reached-top")
            : (window.addEventListener("scroll", () => {
                (0, o.PU)(c);
              }),
              (0, o.PU)(c));
        const d = (e) => {
            const t = e.nextSibling,
              n = t.parentNode.getBoundingClientRect().left,
              o =
                (c.querySelector(".header > .container").getBoundingClientRect()
                  .left,
                t.getBoundingClientRect().width),
              r = t.closest(".container").getBoundingClientRect().width;
            let i = 0;
            if (n + o <= r) t.style.left = 0;
            else {
              var a = r - (n + o + 16);
              (t.style.left = a + "px"),
                t.getBoundingClientRect().left <
                  t.closest(".container").getBoundingClientRect().left &&
                  ((a +=
                    t.closest(".container").getBoundingClientRect().left -
                    t.getBoundingClientRect().left),
                  (t.style.left = a + "px")),
                (i -= a),
                t.querySelector(".nav__tip") &&
                  (t.querySelector(".nav__tip").style.left = i + "px");
            }
          },
          u = () => {
            let e = document.querySelector(".menu-trigger"),
              t = document.querySelector(".nav--mobile");
            e &&
              e.addEventListener("click", (n) => {
                n.stopImmediatePropagation(),
                  e.classList.contains("active")
                    ? (0, o.Wj)(t)
                    : ((0, o.qn)(t, e), (0, i.hO)(!0));
              });
          };
        u();
        const m = () => {
          let e = window.matchMedia("(max-width: 1024px)");
          e.addEventListener("change", () => {
            document.querySelectorAll(".nav").forEach((e) => {
              (0, o.Wj)(e);
            }),
              e.matches && ((c.style.marginTop = 0), (c.props.navMargin = 0));
          });
        };
        m();
        const v = () => {
          c.querySelectorAll(".nav:not(.nav--mobile)").forEach((e) => {
            const t = e.parentNode.getBoundingClientRect().left,
              n = c
                .querySelector(".header > .container")
                .getBoundingClientRect().left,
              o = e.getBoundingClientRect().width,
              r = e.closest(".container").getBoundingClientRect().width;
            let i = 0;
            const a = t + o <= r;
            if (
              (e.querySelector(".nav__tip") &&
                ((e.querySelector(".nav__tip").style.left = 0),
                (i = e.parentNode.classList.contains("multi_level_megamenu")
                  ? t - n + e.parentNode.offsetWidth / 2 - 16
                  : e.parentNode.offsetWidth / 2),
                (e.querySelector(".nav__tip").style.left = i + "px")),
              e.parentNode.classList.contains("multi_level_megamenu"))
            )
              e.style.left = -t + n + "px";
            else if (a) e.style.left = 0;
            else {
              var s = r - (t + o + 16);
              (e.style.left = s + "px"),
                e.getBoundingClientRect().left <
                  e.closest(".container").getBoundingClientRect().left &&
                  ((s +=
                    e.closest(".container").getBoundingClientRect().left -
                    e.getBoundingClientRect().left),
                  (e.style.left = s + "px")),
                (i -= s),
                e.querySelector(".nav__tip") &&
                  (e.querySelector(".nav__tip").style.left = i + "px");
            }
          });
        };
        window.addEventListener("load", function () {
          v();
        }),
          window.addEventListener("resize", () => {
            window.matchMedia("(min-width: 1024px)").matches && v();
          }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              l(), v(), u(), m();
            });
      },
      5837: function (e, t, n) {
        n.d(t, {
          PU: function () {
            return v;
          },
          TS: function () {
            return s;
          },
          Uy: function () {
            return m;
          },
          Wj: function () {
            return c;
          },
          hF: function () {
            return f;
          },
          qn: function () {
            return l;
          },
          sW: function () {
            return u;
          },
        });
        var o = n(6358),
          r = n(4105);
        let i = document.getElementById("nav-wrapper"),
          a = (e, t) => {
            e.props.activeMenu = t;
          };
        const s = (e) => {
            let t;
            e.classList.remove("nav--secondary-menu-open"),
              (t = e.classList.contains("nav--mobile")
                ? e.querySelector(".nav--mobile__inner-container")
                : e.querySelector(".nav__secondary-menu")),
              window.matchMedia("(max-width: 640px)").matches &&
                (e.querySelector(".nav__main-menu-link--active") &&
                  e
                    .querySelector(".nav__main-menu-link--active")
                    .classList.remove("nav__main-menu-link--active"),
                e
                  .querySelectorAll(".nav__secondary-menu__item--animate-in")
                  .forEach((e) => {
                    e.classList.remove("nav__secondary-menu__item--animate-in"),
                      window.setTimeout(() => {
                        e.classList.remove(
                          "nav__secondary-menu__item--visible"
                        ),
                          window.requestAnimationFrame(() => {
                            o.p8.to(t, { height: "auto", duration: 0.3 });
                          });
                      }, 300);
                  }));
          },
          c = (e) => {
            (0, r.hO)(!1),
              s(e),
              a(e, 0),
              i.removeAttribute("style"),
              (i.props.navMargin = 0),
              (i.props.submenuOpen = !1),
              e.classList.remove(
                "nav--open",
                "nav--secondary-menu-open",
                "animation-delay"
              ),
              document.querySelector(".overlay").classList.remove("open"),
              document
                .querySelectorAll(".megamenu-opener, .menu-trigger")
                .forEach((e) => {
                  e.classList.remove("active");
                });
          },
          l = (e, t) => {
            document
              .querySelectorAll(".megamenu-opener, .menu-trigger")
              .forEach((e) => {
                t !== e
                  ? e.classList.remove("active")
                  : t.classList.add("active");
              }),
              document.querySelectorAll(".nav").forEach((t) => {
                t !== e &&
                  t.classList.contains("nav--open") &&
                  (t.classList.remove("nav--open", "animation-delay"),
                  e.classList.add("animation-delay")),
                  t.querySelectorAll("img").forEach((e) => {
                    e.src = e.dataset.src;
                  });
              }),
              (i.props.submenuOpen = !0),
              (i.style.transition = "0.3s"),
              (i.style.marginTop = 0),
              e.classList.add("nav--open"),
              document.querySelector(".overlay").classList.add("open");
          },
          d = (e, t) => {
            e
              ? t.classList.add("nav__mobile-dropdown-wrapper--open")
              : t.classList.remove("nav__mobile-dropdown-wrapper--open");
          },
          u = (e) => {
            e.querySelectorAll(".nav__mobile-dropdown-wrapper").forEach((e) => {
              let t = e.querySelector(".nav__mobile-accordion-opener");
              t &&
                t.addEventListener("click", () => {
                  t
                    .closest(".nav--mobile__column")
                    .querySelectorAll(".nav__mobile-dropdown-wrapper")
                    .forEach((t) => {
                      t !== e &&
                        t.classList.remove(
                          "nav__mobile-dropdown-wrapper--open"
                        );
                    }),
                    e.classList.contains("nav__mobile-dropdown-wrapper--open")
                      ? d(!1, e)
                      : d(!0, e),
                    (t.closest(".nav--mobile__inner-container").style.height =
                      t.closest(".nav__secondary-menu__item").offsetHeight +
                      "px");
                });
            });
          },
          m = (e, t) => {
            let n,
              r = e.getAttribute("data-targetmenu"),
              i = t.querySelector(`#${r}`);
            (n = t.classList.contains("nav--mobile")
              ? t.querySelector(".nav--mobile__inner-container")
              : t.querySelector(".nav__secondary-menu")),
              e.classList.contains("nav__main-menu-link--active") ||
                (t
                  .querySelectorAll(".nav__main-menu-link:not(.simple)")
                  .forEach((e, n) => {
                    a(t, n);
                  }),
                t.querySelectorAll(".nav__main-menu-link").forEach((e) => {
                  e.classList.remove("nav__main-menu-link--active"),
                    e.setAttribute("aria-expanded", !1);
                }),
                e.classList.add("nav__main-menu-link--active"),
                e.setAttribute("aria-expanded", !0),
                e.parentNode.querySelector(
                  ".nav__secondary-navigation-item-content"
                ) &&
                  (window.innerHeight - 140 >
                  e.parentNode.querySelector(
                    ".nav__secondary-navigation-item-content"
                  ).offsetHeight
                    ? (document.querySelector(
                        ".nav--mega_menu .nav__content"
                      ).style.height =
                        e.parentNode.querySelector(
                          ".nav__secondary-navigation-item-content"
                        ).offsetHeight +
                        80 +
                        "px")
                    : (document.querySelector(
                        ".nav--mega_menu .nav__content"
                      ).style.height = window.innerHeight - 140 + "px")),
                t
                  .querySelectorAll(".nav__secondary-menu__item")
                  .forEach((e) => {
                    e.classList.remove("nav__secondary-menu__item--animate-in");
                  }),
                i && i.classList.add("nav__secondary-menu__item--visible"),
                o.p8.to(n, {
                  duration: 0.3,
                  onComplete: () => {
                    t.querySelectorAll(".nav__secondary-menu__item").forEach(
                      (e) => {
                        e !== i
                          ? (e.classList.remove(
                              "nav__secondary-menu__item--animate-in",
                              "nav__secondary-menu__item--visible"
                            ),
                            e.setAttribute("aria-hidden", "true"))
                          : (e.classList.add(
                              "nav__secondary-menu__item--visible"
                            ),
                            e.setAttribute("aria-hidden", "false"),
                            requestAnimationFrame(() => {
                              e.classList.add(
                                "nav__secondary-menu__item--animate-in"
                              );
                            }));
                      }
                    );
                  },
                }));
          },
          v = (e) => {
            let t = window.scrollY - e.props.lastScroll;
            const n = document.getElementById("header-spacer");
            if (
              ((e.props.navMargin += t), e.props.navMargin >= e.offsetHeight)
            ) {
              e.classList.remove("header-visible");
              const t = e.querySelectorAll("details.megamenu-open");
              document.getElementById("overlay").classList.remove("open"),
                t.forEach((e) => {
                  e.classList.remove("active"), e.removeAttribute("open");
                });
            } else e.classList.add("header-visible");
            e.props.submenuOpen
              ? (e.props.navMargin = 0)
              : (e.props.navMargin = Math.max(
                  0,
                  Math.min(e.props.navMargin, e.offsetHeight)
                )),
              e.submenuOpen || (e.style.marginTop = -e.props.navMargin + "px");
            const o = document.querySelector(".sticky"),
              r = document.querySelector("#main-collection-filters");
            o &&
              (0 === o.getBoundingClientRect().y
                ? ((e.props.transformAmount =
                    -e.props.navMargin + e.offsetHeight),
                  e.classList.add("sticky-active"),
                  (o.style.marginTop = -e.props.transformAmount + "px"),
                  (o.style.paddingTop = e.props.transformAmount + "px"),
                  o.classList.add("sticky--stuck"),
                  r && (r.style.marginTop = e.props.transformAmount + "px"))
                : (o.classList.remove("sticky--stuck"),
                  e.classList.remove("sticky-active"),
                  r && (r.style.marginTop = 0))),
              (e.props.lastScroll = Math.max(
                0,
                Math.min(
                  window.scrollY,
                  document.body.offsetHeight - window.innerHeight
                )
              )),
              0 === e.props.lastScroll
                ? (e.classList.add("reached-top"), (n.style.paddingTop = 0))
                : (e.classList.remove("reached-top"),
                  (n.style.paddingTop = e.offsetHeight + "px"));
          },
          p = document.querySelectorAll(".predictive-search"),
          y = document.getElementById("overlay"),
          f = () => {
            y.classList.remove("open"),
              document.body.classList.remove("active", "search"),
              p.forEach((e) => {
                e.classList.remove("open"),
                  (0, r.zx)(e.closest(".predictive-search-wrapper"));
              });
          };
      },
      4105: function (e, t, n) {
        n.d(t, {
          gp: function () {
            return a;
          },
          hO: function () {
            return o;
          },
          zx: function () {
            return c;
          },
        });
        const o = function () {
          let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = window.innerWidth - document.body.offsetWidth;
          const n = document.getElementById("nav-wrapper");
          e
            ? (document.body.classList.add("no-scroll"),
              (document.body.style.paddingRight = t + "px"),
              (n.style.paddingRight = t + "px"))
            : (document.body.classList.remove("no-scroll"),
              (document.body.style.paddingRight = "0px"),
              (n.style.paddingRight = "0px"));
        };
        let r = () => {},
          i = (e) => {
            "Escape" === e.key &&
              (r(), window.removeEventListener("keydown", i));
          };
        const a = function () {
          let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
          t && (r = t),
            e && window.addEventListener("keydown", i),
            e || window.removeEventListener("keydown", i);
        };
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, n, o) {
                return (e /= o / 2) < 1
                  ? (n / 2) * e * e + t
                  : (-n / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                n = document.getElementById("nav-wrapper");
              let o = 0;
              t && (o = t.offsetHeight + 50),
                n && (navWrapperOffset = n.offsetHeight + 50);
              const r = e.offsetTop - o - navWrapperOffset,
                i = window.scrollY,
                a = r - i;
              let s = 0;
              const c = () => {
                s += 5;
                const e = Math.easeInOutQuad(s, i, a, 200);
                window.scrollTo(0, e), s < 200 && setTimeout(c, 5);
              };
              c();
            })(document.querySelector(t));
          });
        });
        const s = {};
        function c() {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          document.removeEventListener("focusin", s.focusin),
            document.removeEventListener("focusout", s.focusout),
            document.removeEventListener("keydown", s.keydown),
            e && e.focus();
        }
      },
    },
    n = {};
  function o(e) {
    var r = n[e];
    if (void 0 !== r) return r.exports;
    var i = (n[e] = { exports: {} });
    return t[e].call(i.exports, i, i.exports, o), i.exports;
  }
  (o.m = t),
    (e = []),
    (o.O = function (t, n, r, i) {
      if (!n) {
        var a = 1 / 0;
        for (d = 0; d < e.length; d++) {
          (n = e[d][0]), (r = e[d][1]), (i = e[d][2]);
          for (var s = !0, c = 0; c < n.length; c++)
            (!1 & i || a >= i) &&
            Object.keys(o.O).every(function (e) {
              return o.O[e](n[c]);
            })
              ? n.splice(c--, 1)
              : ((s = !1), i < a && (a = i));
          if (s) {
            e.splice(d--, 1);
            var l = r();
            void 0 !== l && (t = l);
          }
        }
        return t;
      }
      i = i || 0;
      for (var d = e.length; d > 0 && e[d - 1][2] > i; d--) e[d] = e[d - 1];
      e[d] = [n, r, i];
    }),
    (o.d = function (e, t) {
      for (var n in t)
        o.o(t, n) &&
          !o.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.j = 982),
    (function () {
      var e = { 982: 0, 68: 0, 625: 0 };
      o.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, n) {
          var r,
            i,
            a = n[0],
            s = n[1],
            c = n[2],
            l = 0;
          if (
            a.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (r in s) o.o(s, r) && (o.m[r] = s[r]);
            if (c) var d = c(o);
          }
          for (t && t(n); l < a.length; l++)
            (i = a[l]), o.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return o.O(d);
        },
        n = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
    })();
  var r = o.O(void 0, [216], function () {
    return o(227);
  });
  r = o.O(r);
})();
